import { useEffect, useState } from 'react';

// Matches Tailwind's `md` breakpoint. Used where mobile needs different
// *behaviour*, not just different styling — e.g. tapping a nav section opens
// its submenu on a phone but navigates on a collapsed desktop rail. Pure CSS
// can hide things but cannot change what a click does.
const QUERY = '(max-width: 767px)';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    // Re-sync in case the viewport changed between first render and this effect.
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
